// Hizmet Detay Sayfaları — SEO optimizasyonu için
// Her hizmet benzersiz URL, içerik, FAQ ve metadata içerir

export const SERVICE_PAGES = [
  {
    slug: 'lastik-tamiri',
    title: 'Lastik Tamiri Kocaeli | 7/24 Acil Yerinde Lastik Tamir Hizmeti',
    metaDesc: 'Kocaeli lastik tamiri hizmeti. Patlak lastik, delik lastik, çivi batması — 7/24 yerinde profesyonel lastik tamiri. İzmit, Gebze, Körfez tüm ilçelere ortalama 30 dk.',
    h1: 'Lastik Tamiri',
    h1Accent: 'Kocaeli 7/24 Yerinde Hizmet',
    icon: 'Zap',
    intro: 'Lastiğiniz mi patladı? Çivi mi battı? Kocaeli genelinde 7/24 yerinde lastik tamiri hizmeti sunuyoruz. Mobil ekibimiz bulunduğunuz konuma gelir, profesyonel ekipmanlarla lastiğinizi tamir eder. Servise gitmenize gerek yok — biz geliyoruz.',
    content: `<h2>Kocaeli'de Profesyonel Lastik Tamiri</h2>
<p><strong>Lastik tamiri</strong>, yolda en sık karşılaşılan acil durumlardan biridir. Kocaeli'nin yoğun trafikli yollarında, özellikle <strong>TEM Otoyolu</strong> ve <strong>D-100 Karayolu</strong> üzerinde lastik arızaları sık yaşanır. 7/24 Lastik olarak profesyonel ekibimizle bulunduğunuz noktaya gelip lastiğinizi <strong>yerinde tamir ediyoruz</strong>.</p>

<h3>Hangi Lastik Arızalarını Tamir Ediyoruz?</h3>
<ul>
<li><strong>Çivi ve vida batması:</strong> En yaygın lastik arızası. Yerinde yama ile tamir edilir</li>
<li><strong>Lastik patlaması:</strong> Patlak lastiğin tamiri veya değişimi yapılır</li>
<li><strong>Yan kesik ve çizik:</strong> Durum değerlendirilir, tamir veya değişim önerilir</li>
<li><strong>Hava kaçırma:</strong> Kaçak noktası tespit edilip onarılır</li>
<li><strong>Tüp tamiri:</strong> İç tüplü lastiklerde tüp değişimi ve tamiri</li>
</ul>

<h3>Lastik Tamiri Nasıl Yapılır?</h3>
<p>Profesyonel lastik tamiri birkaç aşamadan oluşur:</p>
<ol>
<li><strong>Hasar tespiti:</strong> Lastiğin iç ve dış yüzeyi incelenir</li>
<li><strong>Lastik sökümü:</strong> Gerekirse lastik janttan sökülür</li>
<li><strong>Yama uygulama:</strong> Profesyonel yama malzemesi ile kalıcı tamir yapılır</li>
<li><strong>Basınç ayarı:</strong> Lastik doğru basınca şişirilir</li>
<li><strong>Güvenlik kontrolü:</strong> Son kontrol yapılıp araç hazır hale getirilir</li>
</ol>

<h3>Kocaeli'de Lastik Tamiri Nerede Yaptırılır?</h3>
<p><strong>7/24 Lastik</strong> mobil servisi ile artık servise gitmenize gerek yok. <strong>İzmit, Gebze, Darıca, Körfez, Derince, Gölcük, Çayırova, Kartepe, Başiskele, Karamürsel, Kandıra ve Dilovası</strong> ilçelerinin tamamına yerinde lastik tamiri hizmeti sunuyoruz. Ortalama <strong>30 dakikada</strong> yanınızdayız.</p>`,
    faqs: [
      { q: 'Lastik tamiri ne kadar sürer?', a: 'Basit bir yama ile tamir ortalama 15-20 dakikada tamamlanır. Karmaşık hasarlarda süre biraz uzayabilir.' },
      { q: 'Tamir edilen lastik güvenli mi?', a: 'Evet, profesyonel yama ve vulkanize tamir yöntemleri ile yapılan tamir kalıcı ve güvenlidir. 24 ay garanti veriyoruz.' },
      { q: 'Lastik tamiri ücreti ne kadar?', a: 'Hasar türüne ve lastik ebadına göre değişir. Arayarak net fiyat bilgisi alabilirsiniz.' },
      { q: 'Gece lastik tamiri yaptırabilir miyim?', a: 'Evet, 7/24 hizmet veriyoruz. Gece yarısı da dahil her saat tamircimiz aktiftir.' },
      { q: 'Yan kesikli lastik tamir edilir mi?', a: 'Yan kesikler genellikle tamir edilemez ve lastik değişimi gerekir. Ekibimiz yerinde değerlendirme yapar.' },
    ],
    relatedServices: ['lastik-degisimi', 'sibop-tamiri', 'stepne-hizmeti'],
    relatedBlogs: ['yolda-lastiginiz-patladiysa-ne-yapmalisiniz', 'lastik-patlamasi-neden-olur-kocaeli-rehber', 'kocaeli-lastik-yol-yardim-hizmeti-nedir'],
    relatedDistricts: ['izmit-lastik-yol-yardim', 'gebze-lastik-yol-yardim', 'korfez-lastik-yol-yardim'],
  },
  {
    slug: 'lastik-degisimi',
    title: 'Lastik Değişimi Kocaeli | 7/24 Yerinde Lastik Montajı Hizmeti',
    metaDesc: 'Kocaeli lastik değişimi hizmeti. Yerinde lastik montajı ve sökümü. Goodyear, Michelin, Bridgestone tüm markalar. İzmit, Gebze 7/24 mobil lastik değişimi.',
    h1: 'Lastik Değişimi',
    h1Accent: 'Yerinde Montaj — Servise Gerek Yok',
    icon: 'Wrench',
    intro: 'Lastik değişimi için servise gitmenize gerek yok. 7/24 Lastik mobil ekibi bulunduğunuz konuma gelip lastiğinizi yerinde değiştirir. Tüm büyük markalar stokta. Binek, ticari ve ağır vasıta lastikleri — hepsine hizmet veriyoruz.',
    content: `<h2>Kocaeli'de Yerinde Lastik Değişimi</h2>
<p><strong>Lastik değişimi</strong>, aracınızın güvenliği için en kritik bakım işlemlerinden biridir. Aşınmış, yaşlanmış veya hasarlı lastiklerle sürüş hem tehlikeli hem de yakıt tüketimini artırır. <strong>7/24 Lastik</strong> olarak Kocaeli genelinde <strong>yerinde lastik değişimi</strong> hizmeti sunuyoruz.</p>

<h3>Lastik Değişimi Ne Zaman Gerekir?</h3>
<ul>
<li><strong>Diş derinliği 1.6mm altına düştüğünde:</strong> Yasal sınır ve güvenlik açısından değişim şarttır</li>
<li><strong>Lastik 5 yaşını geçtiğinde:</strong> Lastik hamuru sertleşir, tutunma azalır</li>
<li><strong>Yan yüzeyde şişkinlik veya çatlak varsa:</strong> Patlama riski nedeniyle acil değişim</li>
<li><strong>Mevsim geçişlerinde:</strong> Yaz-kış lastiği değişimi</li>
<li><strong>Düzensiz aşınma varsa:</strong> Rot-balans sorununa işaret eder</li>
</ul>

<h3>Hangi Lastik Markalarını Takıyoruz?</h3>
<p>Stokumuzda <strong>Goodyear, Michelin, Bridgestone, Lassa, Pirelli, Continental ve Petlas</strong> dahil tüm büyük markaların lastikleri bulunur. Aracınızın ebadına uygun lastiği getirip yerinde montajını yapıyoruz.</p>

<h3>Kocaeli Genelinde Lastik Değişimi</h3>
<p><strong>İzmit, Gebze, Darıca, Körfez, Derince, Çayırova, Kartepe, Başiskele, Gölcük, Karamürsel, Kandıra ve Dilovası</strong> ilçelerinin tamamına mobil lastik değişimi hizmeti sunuyoruz. 4 lastik birden değişimi yaklaşık 45-60 dakikada tamamlanır.</p>`,
    faqs: [
      { q: 'Lastik değişimi ne kadar sürer?', a: 'Tek lastik değişimi 15-20 dakika, 4 lastik birden değişimi 45-60 dakika sürer.' },
      { q: 'Kendi lastiğimi getirtebilir miyim?', a: 'Evet, kendi lastiğinizi temin edebilir veya stokumuzdaki lastiklerden satın alabilirsiniz.' },
      { q: 'Lastik değişimi garantili mi?', a: 'Evet, tüm lastik değişimi işlemlerimiz 24 ay garantilidir.' },
      { q: 'Ticari araç lastik değişimi yapıyor musunuz?', a: 'Evet, kamyon, minibüs, otobüs dahil tüm ticari araçlara yerinde lastik değişimi yapıyoruz.' },
    ],
    relatedServices: ['lastik-tamiri', 'kis-lastigi-takma', 'stepne-hizmeti'],
    relatedBlogs: ['hizli-lastik-degisimi-mobil-servis', 'arac-lastik-omru-nasil-uzatilir', 'gebze-lastik-degisimi-en-hizli-cozum'],
    relatedDistricts: ['gebze-lastik-yol-yardim', 'izmit-lastik-yol-yardim', 'darica-lastik-yol-yardim'],
  },
  {
    slug: 'kis-lastigi-takma',
    title: 'Kış Lastiği Takma Kocaeli | 7/24 Yerinde Kış Lastiği Değişimi',
    metaDesc: 'Kocaeli kış lastiği takma hizmeti. Yerinde kış lastiği montajı ve değişimi. Kartepe, İzmit, Gebze 7/24 mobil kış lastiği servisi.',
    h1: 'Kış Lastiği Takma',
    h1Accent: 'Mevsimlik Değişim — Yerinde Hizmet',
    icon: 'Shield',
    intro: 'Kış lastiği takma zamanı geldi mi? Servise gitmenize gerek yok. 7/24 Lastik mobil ekibi bulunduğunuz konuma gelip kış lastiklerinizi yerinde takar. Kartepe dağ yolları dahil tüm Kocaeli genelinde hizmet veriyoruz.',
    content: `<h2>Kocaeli'de Kış Lastiği Takma Hizmeti</h2>
<p><strong>Kış lastiği</strong>, soğuk hava koşullarında güvenli sürüşün olmazsa olmazıdır. Kocaeli'de özellikle <strong>Kartepe dağ yolları</strong>, <strong>Bolu geçişi</strong> ve kış aylarında buzlanan yollarda kış lastiği hayati önem taşır. 7/24 Lastik olarak kış lastiği takma hizmetini <strong>yerinde</strong> sunuyoruz.</p>

<h3>Kış Lastiği Ne Zaman Takılmalı?</h3>
<ul>
<li><strong>Hava sıcaklığı sürekli 7°C altında olduğunda</strong> kış lastiğine geçilmelidir</li>
<li><strong>Kasım ayı başından itibaren</strong> kış lastiği takmanız önerilir</li>
<li><strong>1 Aralık — 1 Nisan</strong> arası yasal zorunluluk (bazı yollarda)</li>
<li><strong>Kartepe, Bolu, Abant</strong> gibi dağ yollarına çıkacaksanız mutlaka</li>
</ul>

<h3>Kış Lastiği Takma Süreci</h3>
<p>Mobil ekibimiz aracınızın bulunduğu konuma gelir. Yaz lastiklerinizi söker, kış lastiklerinizi takar ve basınç ayarını yapar. İsterseniz <strong>zincir takma</strong> hizmeti de alabilirsiniz. Tüm işlem yaklaşık 45-60 dakikada tamamlanır.</p>

<h3>Hizmet Verdiğimiz Bölgeler</h3>
<p><strong>Kartepe dağ yolları</strong> ve <strong>kayak merkezi güzergahı</strong> dahil, <strong>İzmit, Gebze, Darıca, Körfez, Gölcük, Derince, Çayırova, Başiskele, Karamürsel, Kandıra ve Dilovası</strong> ilçelerinin tamamına kış lastiği takma hizmeti sunuyoruz.</p>`,
    faqs: [
      { q: 'Kış lastiği takma ücreti ne kadar?', a: 'Araç tipine göre değişir. 4 lastik değişimi için arayarak net fiyat alabilirsiniz.' },
      { q: 'Kış lastiğimi kendi getirip taktırabilir miyim?', a: 'Evet, kendi kış lastiklerinizi getirebilir veya stokumuzdaki kış lastiklerinden satın alabilirsiniz.' },
      { q: 'Kış lastiği ne zaman çıkarılmalı?', a: 'Hava sıcaklığı sürekli 7°C üzerinde olduğunda, genellikle Mart sonu — Nisan başı kış lastiğinizi çıkarmanız önerilir.' },
      { q: 'Kartepe dağ yolunda kış lastiği taktırabilir miyim?', a: 'Evet, Kartepe dağ yolları ve kayak merkezi güzergahına mobil ekibimiz ile gelip yerinde kış lastiği takıyoruz.' },
    ],
    relatedServices: ['lastik-degisimi', 'zincir-takma', 'lastik-tamiri'],
    relatedBlogs: ['yaz-aylarinda-lastik-kullanimi-rehberi', 'yolda-kalmamak-icin-7-lastik-tavsiyesi', 'uzun-yola-cikmadan-lastik-kontrolu'],
    relatedDistricts: ['kartepe-lastik-yol-yardim', 'izmit-lastik-yol-yardim', 'golcuk-lastik-yol-yardim'],
  },
  {
    slug: 'sibop-tamiri',
    title: 'Sibop Tamiri Kocaeli | 7/24 Yerinde Sibop Değişimi Hizmeti',
    metaDesc: 'Kocaeli sibop tamiri ve değişimi. Lastiğiniz sürekli iniyor mu? 7/24 yerinde sibop tamiri hizmeti. İzmit, Gebze tüm ilçelere mobil servis.',
    h1: 'Sibop Tamiri',
    h1Accent: 'Hava Kaçağına Son — Yerinde Çözüm',
    icon: 'CheckCircle',
    intro: 'Lastiğiniz sürekli hava kaybediyor mu? Büyük ihtimalle sibop arızası. 7/24 Lastik mobil ekibi bulunduğunuz konuma gelip sibop tamiri veya değişimini yerinde yapar. Hızlı ve kalıcı çözüm garantisi.',
    content: `<h2>Sibop Tamiri Neden Önemli?</h2>
<p><strong>Sibop arızası</strong>, lastiğin yavaş yavaş hava kaybetmesine neden olan yaygın bir sorundur. Fark edilmediğinde düşük basınçla sürüş güvenliği azalır, yakıt tüketimi artar ve lastik ömrü kısalır. <strong>Kocaeli</strong> gibi yoğun trafikli bölgelerde bu durum tehlike yaratabilir.</p>

<h3>Sibop Arızası Belirtileri</h3>
<ul>
<li><strong>Lastik sürekli iniyor:</strong> Şişirdikten kısa süre sonra tekrar iniyorsa sibop arızası olabilir</li>
<li><strong>Basınç uyarı lambası:</strong> Araç göstergesinde lastik basınç uyarısı yanıyorsa</li>
<li><strong>Sabah lastik düz:</strong> Gece park edip sabah lastik inmiş buluyorsanız</li>
<li><strong>Siboptan hava sesi:</strong> Sibopa su döktüğünüzde kabarcık çıkıyorsa</li>
</ul>

<h3>Sibop Tamiri Nasıl Yapılır?</h3>
<p>Ekibimiz sibop arızasını yerinde tespit edip onarır. Sibop çekirdeği değişimi veya komple sibop değişimi yapılır. İşlem ortalama <strong>10-15 dakikada</strong> tamamlanır. Tüm sibop tipleri (standart, TPMS sensörlü, ağır vasıta) için hizmet veriyoruz.</p>

<h3>Kocaeli Genelinde Sibop Tamiri</h3>
<p><strong>İzmit, Gebze, Darıca, Körfez, Derince, Çayırova, Kartepe, Başiskele, Gölcük, Karamürsel, Kandıra ve Dilovası</strong> ilçelerinin tamamına 7/24 mobil sibop tamiri hizmeti sunuyoruz.</p>`,
    faqs: [
      { q: 'Sibop tamiri ne kadar sürer?', a: 'Sibop tamiri veya değişimi ortalama 10-15 dakikada tamamlanır.' },
      { q: 'Sibop arızası tehlikeli mi?', a: 'Evet, düşük basınçla sürüş frenleme mesafesini uzatır, lastik patlaması riskini artırır.' },
      { q: 'TPMS sensörlü sibop değişimi yapıyor musunuz?', a: 'Evet, TPMS sensörlü lastiklerde de sibop değişimi yapıyoruz.' },
    ],
    relatedServices: ['lastik-tamiri', 'lastik-degisimi', 'jant-onarimi'],
    relatedBlogs: ['lastik-basinci-kontrolu-neden-onemli', 'lastik-basinci-arac-guvenligine-etkisi', 'arac-lastik-bakimi-rehberi'],
    relatedDistricts: ['izmit-lastik-yol-yardim', 'derince-lastik-yol-yardim', 'cayirova-lastik-yol-yardim'],
  },
  {
    slug: 'stepne-hizmeti',
    title: 'Stepne Hizmeti Kocaeli | 7/24 Yerinde Stepne Montajı',
    metaDesc: 'Kocaeli stepne hizmeti. Stepne montajı, stepne yoksa yeni lastik temin. 7/24 yerinde mobil stepne servisi. İzmit, Gebze tüm ilçelere hizmet.',
    h1: 'Stepne Hizmeti',
    h1Accent: 'Stepneniz Yoksa Bile Çözüm Var',
    icon: 'ArrowRight',
    intro: 'Stepneniz var ama takamıyor musunuz? Yoksa stepneniz hiç yok mu? Endişelenmeyin. 7/24 Lastik mobil ekibi bulunduğunuz konuma gelip stepne montajı yapar veya yeni lastik getirip yerinde takar.',
    content: `<h2>Stepne Hizmeti Nedir?</h2>
<p><strong>Stepne hizmeti</strong>, lastik patlaması durumunda yedek lastiğin (stepne) profesyonel şekilde takılması veya stepne bulunmadığında yeni lastik temin edilerek yerinde montajının yapılmasıdır. Modern araçların birçoğu artık stepne ile gelmemektedir, bu da yolda kalma riskini artırır.</p>

<h3>Stepne Hizmeti Kapsamı</h3>
<ul>
<li><strong>Stepne montajı:</strong> Mevcut stepnenizin profesyonel şekilde takılması</li>
<li><strong>Yeni lastik temin:</strong> Stepneniz yoksa aracınıza uygun lastik getiriyoruz</li>
<li><strong>Güvenli kaldırma:</strong> Profesyonel kriko ile aracın güvenli şekilde kaldırılması</li>
<li><strong>Bijon torku ayarı:</strong> Bijon sıkma torkunda doğru ayar yapılması</li>
<li><strong>Basınç kontrolü:</strong> Takılan lastiğin doğru basınca şişirilmesi</li>
</ul>

<h3>Modern Araçlarda Stepne Sorunu</h3>
<p>Birçok yeni model araç artık stepne yerine tamir kiti ile satılmaktadır. Bu kitler küçük deliklerde geçici çözüm sağlasa da, <strong>lastik patlaması</strong> veya büyük hasarlarda yetersiz kalır. Bu durumda <strong>7/24 Lastik</strong> mobil servisi en hızlı çözümdür.</p>

<h3>Kocaeli Genelinde Stepne Hizmeti</h3>
<p><strong>İzmit, Gebze, Darıca, Körfez, Derince, Çayırova, Gölcük, Kartepe, Başiskele, Karamürsel, Kandıra ve Dilovası</strong> ilçelerinin tamamına 7/24 stepne hizmeti sunuyoruz. Ortalama <strong>30 dakikada</strong> yanınızdayız.</p>`,
    faqs: [
      { q: 'Stepnem yoksa ne yapmalıyım?', a: 'Bizi arayın. Aracınıza uygun lastik getirip yerinde montaj yapıyoruz.' },
      { q: 'Stepne montajı ne kadar sürer?', a: 'Stepne montajı ortalama 15-20 dakikada tamamlanır.' },
      { q: 'Patlak lastikle sürüş yapabilir miyim?', a: 'Kesinlikle hayır. Patlak lastikle sürüş janta zarar verir ve ciddi kaza riski taşır.' },
    ],
    relatedServices: ['lastik-tamiri', 'lastik-degisimi', 'sibop-tamiri'],
    relatedBlogs: ['stepne-yoksa-ne-yapmalisiniz', 'yolda-lastiginiz-patladiysa-ne-yapmalisiniz', 'kocaeli-724-lastik-yol-yardim-nasil-calisir'],
    relatedDistricts: ['izmit-lastik-yol-yardim', 'gebze-lastik-yol-yardim', 'golcuk-lastik-yol-yardim'],
  },
  {
    slug: 'jant-onarimi',
    title: 'Jant Onarımı Kocaeli | 7/24 Yerinde Jant Tamiri ve Değerlendirme',
    metaDesc: 'Kocaeli jant onarımı hizmeti. Jant eğriliği, jant çatlağı, jant hasarı — 7/24 yerinde jant değerlendirmesi ve onarımı. İzmit, Gebze mobil servis.',
    h1: 'Jant Onarımı',
    h1Accent: 'Yerinde Jant Değerlendirme ve Tamir',
    icon: 'Clock',
    intro: 'Çukur veya kaldırıma bindirme sonucu jantınız eğrildi mi? Jant eğriliği lastik hava kaçağına ve dengesiz sürüşe neden olur. 7/24 Lastik mobil ekibi yerinde jant değerlendirmesi ve onarımı hizmeti sunar.',
    content: `<h2>Jant Onarımı Neden Önemli?</h2>
<p><strong>Jant arızası</strong>, genellikle çukur, kasis veya kaldırıma çarpma sonucu oluşur. Eğrilmiş veya çatlamış bir jant, lastik hava kaçağına, titreşime ve güvensiz sürüşe neden olur. <strong>Kocaeli</strong> yollarındaki çukurlar ve kötü yol koşulları jant arızalarını artırmaktadır.</p>

<h3>Jant Arızası Belirtileri</h3>
<ul>
<li><strong>Direksiyon titremesi:</strong> Özellikle yüksek hızlarda hissedilen titreşim</li>
<li><strong>Sürekli hava kaybı:</strong> Lastik şişirildikten sonra tekrar inmesi</li>
<li><strong>Dengesiz sürüş:</strong> Aracın bir tarafa çekme yapması</li>
<li><strong>Görünür eğrilik:</strong> Jant kenarında gözle görülen eğrilik veya çatlak</li>
</ul>

<h3>Jant Onarımı Kapsamı</h3>
<ul>
<li><strong>Jant eğrilik tespiti:</strong> Profesyonel görsel muayene</li>
<li><strong>Yerinde değerlendirme:</strong> Jantın onarılabilir olup olmadığının tespiti</li>
<li><strong>Hava kaçak tespiti:</strong> Jant-lastik oturma yüzeyinin kontrolü</li>
<li><strong>Gerekirse jant değişimi:</strong> Onarılamaz durumlarda jant değişimi önerisi</li>
</ul>

<h3>Kocaeli Genelinde Jant Onarımı</h3>
<p><strong>İzmit, Gebze, Darıca, Körfez, Derince, Çayırova, Kartepe, Başiskele, Gölcük, Karamürsel, Kandıra ve Dilovası</strong> ilçelerinin tamamına 7/24 jant değerlendirme ve onarım hizmeti sunuyoruz.</p>`,
    faqs: [
      { q: 'Jant eğriliği tehlikeli mi?', a: 'Evet, jant eğriliği lastik hava kaçağı, titreşim ve fren performansı düşüşüne neden olur.' },
      { q: 'Eğrilmiş jant tamir edilebilir mi?', a: 'Çoğu durumda evet. Ancak çatlamış veya kırılmış jantlar değiştirilmelidir.' },
      { q: 'Jant onarımı yerinde yapılır mı?', a: 'Yerinde değerlendirme yapılır. Basit onarımlar yerinde, kompleks durumlar servise yönlendirilir.' },
    ],
    relatedServices: ['lastik-tamiri', 'sibop-tamiri', 'lastik-degisimi'],
    relatedBlogs: ['arac-lastik-bakimi-rehberi', 'lastik-patlamasi-neden-olur-kocaeli-rehber', 'uzun-yola-cikmadan-lastik-kontrolu'],
    relatedDistricts: ['izmit-lastik-yol-yardim', 'gebze-lastik-yol-yardim', 'darica-lastik-yol-yardim'],
  },
  {
    slug: 'zincir-takma',
    title: 'Zincir Takma Kocaeli | 7/24 Kar Zinciri Takma Hizmeti Kartepe',
    metaDesc: 'Kocaeli zincir takma hizmeti. Kartepe dağ yolları, buzlu yollar — 7/24 yerinde kar zinciri takma. Kış koşullarında güvenli sürüş.',
    h1: 'Zincir Takma',
    h1Accent: 'Kış Yollarında Güvenli Sürüş',
    icon: 'Shield',
    intro: 'Kartepe dağ yolları, Bolu geçişi veya buzlanmış yollarda mısınız? 7/24 Lastik mobil ekibi bulunduğunuz konuma gelip kar zinciri takma hizmeti sunar. Doğru zincir boyutu kontrolü ve güvenli montaj garantisi.',
    content: `<h2>Kocaeli'de Zincir Takma Hizmeti</h2>
<p><strong>Kar zinciri takma</strong>, kış aylarında özellikle dağ yolları ve buzlanmış güzergahlarda güvenli sürüş için zorunludur. Kocaeli'de <strong>Kartepe dağ yolları</strong>, <strong>kayak merkezi güzergahı</strong> ve kış döneminde buzlanan şehir içi yollarda zincir takma hizmeti veriyoruz.</p>

<h3>Zincir Takma Ne Zaman Gerekir?</h3>
<ul>
<li><strong>Kartepe dağ yollarında:</strong> Özellikle kayak sezonu (Aralık-Mart)</li>
<li><strong>Buzlanmış yollarda:</strong> Sıfır altı sıcaklıklarda</li>
<li><strong>Kar yağışı sırasında:</strong> Yoğun kar yağışında zincir şart</li>
<li><strong>Trafik polisi zorunlu kıldığında:</strong> Dağ geçitlerinde zincir kontrolü yapılır</li>
</ul>

<h3>Zincir Takma Süreci</h3>
<ol>
<li><strong>Boyut kontrolü:</strong> Zincirin lastik ebadına uygunluğu kontrol edilir</li>
<li><strong>Montaj:</strong> Zincir profesyonel şekilde takılır</li>
<li><strong>Sıkma kontrolü:</strong> 50 metre sonra sıkma kontrolü yapılır</li>
<li><strong>Güvenlik tavsiyeleri:</strong> Zincirliyken maksimum hız ve sürüş teknikleri anlatılır</li>
</ol>

<h3>Hizmet Verdiğimiz Bölgeler</h3>
<p><strong>Kartepe</strong> dağ yolları başta olmak üzere <strong>İzmit, Gebze, Gölcük, Başiskele, Karamürsel</strong> ve tüm Kocaeli genelinde 7/24 zincir takma hizmeti sunuyoruz.</p>`,
    faqs: [
      { q: 'Zincir takma ne kadar sürer?', a: 'Dört tekerleke zincir takılması ortalama 15-20 dakikada tamamlanır.' },
      { q: 'Kendi zincirim yoksa siz getirir misiniz?', a: 'Evet, aracınıza uygun zincir temin edip yerinde takıyoruz.' },
      { q: 'Zincirliyken ne kadar hızla gidebilirim?', a: 'Zincirliyken maksimum 40-50 km/h hız önerilir. Ani fren ve manevralardan kaçının.' },
      { q: 'Kartepe dağ yoluna zincir takma hizmeti geliyor mu?', a: 'Evet, Kartepe dağ yolları ve kayak merkezi güzergahına ekibimiz ile geliyoruz.' },
    ],
    relatedServices: ['kis-lastigi-takma', 'lastik-degisimi', 'lastik-tamiri'],
    relatedBlogs: ['yolda-kalmamak-icin-7-lastik-tavsiyesi', 'uzun-yola-cikmadan-lastik-kontrolu', 'kocaeli-7-24-lastikci-acil-yol-yardim'],
    relatedDistricts: ['kartepe-lastik-yol-yardim', 'golcuk-lastik-yol-yardim', 'basiskele-lastik-yol-yardim'],
  },
];

// Helper: slug ile hizmet bul
export const getServiceBySlug = (slug) => SERVICE_PAGES.find(s => s.slug === slug);

// Tüm hizmet slug'ları (route oluşturma için)
export const ALL_SERVICE_SLUGS = SERVICE_PAGES.map(s => s.slug);

// Hizmet adı lookup
export const SERVICE_NAMES = {};
SERVICE_PAGES.forEach(s => { SERVICE_NAMES[s.slug] = s.h1; });
